export const TYPE_OPTIONS = [
	{ key: "string", text: "string", value: "string" },
	{ key: "number", text: "number", value: "number" },
	{ key: "date", text: "date", value: "date" },
	{ key: "file", text: "file", value: "file" },
	{ key: "dropdown", text: "dropdown", value: "dropdown" },
	{ key: "group", text: "group", value: "group" },
	{ key: "menu", text: "menu", value: "menu" },
];

export const ACQ_OPTIONS = [
	{ key: "static", text: "static", value: "static" },
	{ key: "generated", text: "generated", value: "generated" },
];
